import { UserDelegationTargetKindEnum } from '@zaoblako/shared/modules/security/enums/user-delegation-target-kind.enum';
import { UserDelegationTargetKindEnumI18n } from '@zaoblako/shared/modules/security/i18n/user-delegation-target-kind-enum.i18n';
import { UserDelegationTargetTypeEnum } from '@zaoblako/shared/modules/security/enums/user-delegation-target-type.enum';
import { UserDelegationTargetTypeEnumI18n } from '@zaoblako/shared/modules/security/i18n/user-delegation-target-type-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';

import * as yup from 'yup';

/** User delegation created and update APis request body - DTO signature */
export interface UserDelegationFormInterface {
  /** The user whose objects are to be delegated */
  fromUser: OnlyIdRequiredInterface<UserFindInterface>;
  /** Delegation target kind */
  kind: UserDelegationTargetKindEnum;
  /** Delegation target type */
  type: UserDelegationTargetTypeEnum;
  /** The user to whom the objects will be delegated */
  toUser: OnlyIdRequiredInterface<UserFindInterface>;
  /** If `true` then all new target objects will be automatically delegated */
  active?: boolean;
}

/** User delegation created and update APis request body - DTO signature */
export const UserDelegationFormDto = SerdeDtoClass.create<UserDelegationFormInterface>(SecurityDtoKeysEnum.USER_DELEGATION_FORM_DTO, {
  fromUser: {
    label: 'Делегирующий',
    hint: 'Пользователь, чьи дела надо делегировать',
    serializer: entityLikeSchema,
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  kind: {
    label: 'Объект',
    serializer: commonEnumValidator(UserDelegationTargetKindEnum, UserDelegationTargetKindEnumI18n),
  },
  type: {
    label: 'Тип участника',
    serializer: commonEnumValidator(UserDelegationTargetTypeEnum, UserDelegationTargetTypeEnumI18n),
  },
  toUser: {
    label: 'Принимающий',
    hint: 'Пользователь, которому надо делегировать дела',
    serializer: entityLikeSchema,
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  active: {
    optional: true,
    label: 'Активное',
    hint: 'Если делегирование активно, то все новые дела будут автоматически передаваться принимающему',
    serializer: yup.boolean(),
  },
});
